import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import QuickContact from './components/QuickContact';
import LocationsSection from './components/LocationsSection';
import ContactForm from './components/ContactForm';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <Hero />
        <QuickContact />
        <LocationsSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}